import { Navigate } from 'react-router-dom';
import { useHomePageFeature } from '@/hooks/featureFlags';
import { useUrlLocale } from '@/hooks/useUrlLocale';
import { RedirectToTeam } from './RedirectToTeam';

export const RedirectToLanding = () => {
  const isHomePageEnabled = useHomePageFeature();
  const locale = useUrlLocale();

  return isHomePageEnabled ? <Navigate to={`/${locale}/home`} replace /> : <RedirectToTeam />;
};
